import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { reducer } from './reducer';
import { DisbursementStoreEffects } from './effects';
import { StoreModule } from '@ngrx/store';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('disbursement', reducer),
        EffectsModule.forFeature([DisbursementStoreEffects])
    ],
    providers: []
})
export class DisbursementStoreModule {}
